import { combineReducers } from 'redux';
import snackbarReducer from './snackbarReducer';
import responseReducer from './responseReducer';
import areaReducer from './areaReducer';
import cleaningAreasReducer from './cleaningAreasReducer';
import optionsReducer from './optionsReducer';
import tabReducer from './tabReducer';
import btnReducer from './btnReducer';
import cleanTsReducer from './cleanTsReducer';

const reducers = combineReducers({
  snackbar: snackbarReducer,
  response: responseReducer,
  area: areaReducer,
  cleaningAreas: cleaningAreasReducer,
  options: optionsReducer,
  activeTab: tabReducer,
  activeBtn: btnReducer,
  cleanTs: cleanTsReducer,
});

export default reducers;
